'use client'

import React from 'react'
import Image from 'next/image'
import AnimatedSection from '@/components/AnimatedSection'
import styles from './styles.module.css'

// ЗАГЛУШКИ: пути к 3 вариантам картинки (десктоп/планшет/моб) — заменить на свои
const imageDesktop = '/images/b2c/easy_of_use_desktop.svg'
const imageTablet = '/images/b2c/easy_of_use_tablet.svg'
const imageMobile = '/images/b2c/easy_of_use_mobile.svg'

const EasyOfUse: React.FC = () => {
	return (
		<section className={styles.easyOfUse}>
			<div className={styles.content}>
				<AnimatedSection animation='slideUp'>
					<div className={styles.subtitle}>Простота использования</div>
					<h2
						className={styles.title}
						dangerouslySetInnerHTML={{ __html: '<span>Простая транзакция</span> с бизнес-карты физлицу за пару минут' }}
					/>
				</AnimatedSection>
				<AnimatedSection animation='slideUp'>
					<p
						className={styles.description}
						dangerouslySetInnerHTML={{
							__html:
								'Интерфейс спроектирован по принципу кратчайшего пути до достижения цели — <span>сотрудник тратит минимум времени</span> на оформление транзакции. Такой формат процесса <span>сокращает количество ошибок</span> и ускоряет привычные паттерны без рисков для вашего бизнеса.'
						}}
					/>
				</AnimatedSection>
			</div>
			<AnimatedSection animation='slideUp'>
				<div className={styles.visual}>
					<Image
						src={imageDesktop}
						alt='Простая транзакция'
						width={1110}
						height={496}
						className={styles.desktopImage}
						unoptimized
					/>
					<Image
						src={imageTablet}
						alt='Простая транзакция'
						width={680}
						height={304}
						className={styles.tabletImage}
						unoptimized
					/>
					<Image
						src={imageMobile}
						alt='Простая транзакция'
						width={328}
						height={780}
						className={styles.mobileImage}
						unoptimized
					/>
				</div>
			</AnimatedSection>
		</section>
	)
}

EasyOfUse.displayName = 'EasyOfUse'

export default EasyOfUse
